<template>
  <div class="finance-picker" :class="show?'showpdbtm':''">
    <table class="date-picker">
      <thead>
        <tr class="date-head">
          <th colspan="7">
            <i v-if="show" class="icon-menu icon-left" @click="monthClick(-1)"></i>
            <span class="show-yearmonth">{{curDate.getFullYear()}}年{{curDate.getMonth()+1}}月(北京时间)</span>
            <i v-if="show" class="icon-menu icon-right" @click="monthClick(1)"></i>
            <span v-if="show" @click="hiddenMonth" class="cancel"></span>
            <span v-if="!show" @click="showMonth" class="time-icon"></span>
          </th>
        </tr>
      </thead>
    </table>
    <table class="table">
      <tbody class="tbody1" v-show="!show" id="touchBox2">
        <tr>
          <td
            v-for="(weekname,index) in weekList"
            :class="checkSelectWeek(index)"
          >&nbsp;{{weekname}}&nbsp;</td>
        </tr>
        <tr>
          <td
            v-for="(item,index) in lineDatalist"
            :class="item.classStr"
            style="height:30px"
            @click="selectline(item.date)"
          >&nbsp;{{item.date.getDate()}}&nbsp;</td>
        </tr>
      </tbody>
      <tbody class="tbody2" v-show="show" id="touchBox1">
        <tr>
          <td v-for="(weekname,index) in weekList">&nbsp;{{weekname}}&nbsp;</td>
        </tr>
        <tr>
          <td v-for="(item, index) in lineMonthDatalist.slice(0,7)">
            <div
              :class="item.classStr"
              @click="selectMonthDay(item.date)"
            >&nbsp;{{item.date.getDate()}}&nbsp;</div>
          </td>
        </tr>
        <tr>
          <td v-for="(item, index) in lineMonthDatalist.slice(7,14)">
            <div
              :class="item.classStr"
              @click="selectMonthDay(item.date)"
            >&nbsp;{{item.date.getDate()}}&nbsp;</div>
          </td>
        </tr>
        <tr>
          <td v-for="(item, index) in lineMonthDatalist.slice(14,21)">
            <div
              :class="item.classStr"
              @click="selectMonthDay(item.date)"
            >&nbsp;{{item.date.getDate()}}&nbsp;</div>
          </td>
        </tr>
        <tr>
          <td v-for="(item, index) in lineMonthDatalist.slice(21,28)">
            <div
              :class="item.classStr"
              @click="selectMonthDay(item.date)"
            >&nbsp;{{item.date.getDate()}}&nbsp;</div>
          </td>
        </tr>
        <tr>
          <td v-for="(item, index) in lineMonthDatalist.slice(28,35)">
            <div
              :class="item.classStr"
              @click="selectMonthDay(item.date)"
            >&nbsp;{{item.date.getDate()}}&nbsp;</div>
          </td>
        </tr>
        <tr>
          <td v-for="(item, index) in lineMonthDatalist.slice(35,42)">
            <div
              :class="item.classStr"
              @click="selectMonthDay(item.date)"
            >&nbsp;{{item.date.getDate()}}&nbsp;</div>
          </td>
        </tr>
      </tbody>
    </table>
    <!-- <div v-if="!show" style="height:3px;background: #F7F8FA; border-top:1px solid #ccc;"></div> -->
  </div>
</template>
    <style>
 body.white-skin .table {
  width: 100%;
  background-color:#f7f8fa
}
 body .table {
  width: 100%;
  background-color:#272727
}
.table thead tr th {
  font-weight: 400;
  font-size: 1.5rem;
}
body.white-skin .tbody1 tr td {
  text-align: center;
  height: 28px;
  font-weight: 400;
  font-size: 1.5rem;
  color: #282828;
}
body .tbody1 tr td {
  text-align: center;
  height: 28px;
  font-weight: 400;
  font-size: 1.5rem;
  color: #fff;
  
}
body .tbody2 tr td {
  text-align: center;
  height: 40px;
  font-weight: 400;
  font-size: 1.5rem;
  color: #fff;
}
body.white-skin .tbody2 tr td {
  text-align: center;
  height: 40px;
  font-weight: 400;
  font-size: 1.5rem;
  color: #282828;
}
.tbody2 tr td div {
  line-height: 30px;
  margin: 0 auto;
}
body.white-skin .em-tab .tab-list .tab-li:after {
  border-top: 1px solid #ccc;
}
.prenext-date {
  color: #999;
}
body.white-skin .date-now {
  background: #ea5604;
}
body .date-now {
  background:#3274c2;
}
body.white-skin .date-active {
  border-radius: 50%;
  background: #ea5604;
  width: 2.6rem;
  height: 2.6rem;
}
body .date-active {
  border-radius: 50%;
  background:#3274c2;
  width: 2.6rem;
  height: 2.6rem;
}
body.white-skin .curline-index {
  background: #ea5604;
}
body .curline-index {
  background:#3274c2;
}
</style>
<script>
const util = require("@/utils/tool.js");
var tody = new Date();
export default {
  name: "finance-picker-new",
  props: {
    format: {
      type: String,
      default: "-"
    }
  },
  data() {
    return {
      curDate: tody,
      lineDatalist: [],
      lineMonthDatalist: [],
      selectDate: tody,
      show: false,
      weekList: ["日", "一", "二", "三", "四", "五", "六"]
    };
  },
  created() {
    this.initWeek(tody, true);
  },
  methods: {
    //初始化一周的数据
    initWeek(thisDay, isSelect) {
      this.lineDatalist = [];
      thisDay = thisDay ? thisDay : tody;
      this.curDate = thisDay;
      var nowTime = thisDay.getTime();
      var day = thisDay.getDay();
      var oneDayLong = 24 * 60 * 60 * 1000;
      for (var a = 0; a < 7; a++) {
        var wday = new Date(nowTime - (day - a) * oneDayLong);
        var classStr = "";
        //是否添加自动选中
        if (isSelect && this.compareDate(thisDay, wday)) {
          classStr = " date-now";
          this.selectDate = wday;
        }
        classStr +=
          thisDay.getMonth() == wday.getMonth() ? "" : " prenext-date";
        var single = {
          date: wday,
          classStr: classStr
        };
        this.lineDatalist.push(single);
      }
    },
    //加载月数据
    initMonth(direction) {
      this.animateClass(direction, util.getId("touchBox1"));
      if (direction) {
        this.curDate =
          direction > 0
            ? new Date(this.curDate.setMonth(this.curDate.getMonth() + 1))
            : new Date(this.curDate.setMonth(this.curDate.getMonth() - 1));
      }
      this.lineMonthDatalist = [];
      var start = new Date(
        this.curDate.getFullYear(),
        this.curDate.getMonth(),
        1
      );
      for (var a = 0; a < 31; a++) {
        var temp = this.addDate(start, a);
        if (temp.getMonth() != this.curDate.getMonth()) {
          break;
        }
        let classStr = "";
        if (this.compareDate(temp, this.selectDate)) {
          classStr = "  date-active";
        }
        this.lineMonthDatalist.push({
          date: temp,
          classStr: classStr
        });
      }
      //补够6行42天
      var first = this.lineMonthDatalist[0].date;
      if (first.getDay() != 0) {
        for (var b = 1; b <= first.getDay(); b++) {
          var addD = this.addDate(first, -b);
          let classStr = "";
          if (this.compareDate(addD, this.selectDate)) {
            classStr = "  date-active";
          }
          this.lineMonthDatalist.unshift({
            date: addD,
            classStr: classStr + " prenext-date"
          });
        }
      }
      var last = this.lineMonthDatalist[this.lineMonthDatalist.length - 1].date;
      if (last.getDay() != 6) {
        let loop = 1;
        for (var b = last.getDay() + 1; b <= 6; b++) {
          var addD = this.addDate(last, loop);
          let classStr = "";
          if (this.compareDate(addD, this.selectDate)) {
            classStr = "  date-active";
          }
          this.lineMonthDatalist.push({
            date: addD,
            classStr: classStr + " prenext-date"
          });
          loop++;
        }
      }
      console.log(this.lineMonthDatalist);
    },
    //左右滑动（月）
    monthClick(direction) {
      this.initMonth(direction);
    },
    //左右滑动（周）
    lineClick(direction) {
      this.animateClass(direction, util.getId("touchBox2"));
      if (direction == 1) {
        var startday = this.lineDatalist[6].date;
        this.lineDatalist = [];
        var lastDay = this.addDate(startday, 7);
        this.curDate = lastDay;
        for (var a = 0; a < 7; a++) {
          var nextDay = this.addDate(startday, a + 1);
          var classStr = "";
          if (this.compareDate(nextDay, this.selectDate)) {
            classStr = " date-now";
          }
          classStr +=
            nextDay.getMonth() == this.curDate.getMonth()
              ? ""
              : " prenext-date";
          var single = { date: nextDay, classStr: classStr };
          this.lineDatalist.push(single);
        }
        console.log(this.lineDatalist);
      } else {
        var startday = this.lineDatalist[0].date;
        this.lineDatalist = [];
        var firstDay = this.addDate(startday, -7);

        this.curDate = firstDay;
        for (var a = 0; a < 7; a++) {
          var nextDay = this.addDate(startday, -(7 - a));
          var classStr = "";
          if (this.compareDate(nextDay, this.selectDate)) {
            classStr = " date-now";
          }
          classStr +=
            nextDay.getMonth() == this.curDate.getMonth()
              ? ""
              : " prenext-date";
          var single = { date: nextDay, classStr: classStr };
          this.lineDatalist.push(single);
        }
        console.log(this.lineDatalist);
      }
    },
    //周列表选中日期
    selectline(selectDay) {
      this.initWeek(selectDay, true);
      this.$emit("click", this.selectDate);
    },
    //月份中选中日期
    selectMonthDay(selectDay) {
      this.selectDate = selectDay;
      this.initWeek(selectDay, true);
      this.initMonth();
      this.$emit("click", this.selectDate);
      this.show = false;
    },
    //显示月份
    showMonth() {
      this.initMonth();
      this.show = true;
    },
    //隐藏月份
    hiddenMonth() {
      this.show = false;
      //回填当前月第一周数据，并判断是否有当前选中数据
      var select = this.lineMonthDatalist.find(
        n =>
          n.date.getFullYear() == this.selectDate.getFullYear() &&
          n.date.getMonth() == this.selectDate.getMonth() &&
          n.date.getDate() == this.selectDate.getDate()
      );
      if (select) {
        this.initWeek(select.date, true);
      } else {
        var firstweek=this.lineMonthDatalist.find(n=>n.date.getDay()==0&&n.classStr=="")
        this.initWeek(firstweek.date, false);
      }
      this.lineMonthDatalist = [];
      //这里肯定没选日期就关闭了，让控件回到原始状态
      // this.initWeek(this.selectDate, true);
      //console.log(this.selectDate);
    },
    //比较两个日期是否相等
    compareDate(d1, d2) {
      let c1 = d1.getFullYear() + "" + d1.getMonth() + "" + d1.getDate();
      let c2 = d2.getFullYear() + "" + d2.getMonth() + "" + d2.getDate();
      if (c1 == c2) {
        return true;
      }
      return false;
    },
    //当前日期加减某天后的日期
    addDate(d, add) {
      return new Date(d.getTime() + add * 24 * 60 * 60 * 1000);
    },
    checkSelectWeek(index) {
      if (!this.selectDate || this.selectDate.getDay() != index) {
        return "";
      }
      for (var s = 0; s < this.lineDatalist.length; s++) {
        if (this.compareDate(this.lineDatalist[s].date, this.selectDate)) {
          return "curline-index";
        }
      }
      return "";
    },
    GetSlideAngle(dx, dy) {
      return (Math.atan2(dy, dx) * 180) / Math.PI;
    },
    GetSlideDirection(startX, startY, endX, endY) {
      var dy = startY - endY;
      var dx = endX - startX;
      var result = 0;
      //如果滑动距离太短
      if (Math.abs(dx) < 2 && Math.abs(dy) < 2) {
        return result;
      }
      var angle = this.GetSlideAngle(dx, dy);
      if (angle >= -45 && angle < 45) {
        result = 4;
      } else if (angle >= 45 && angle < 135) {
        result = 1;
      } else if (angle >= -135 && angle < -45) {
        result = 2;
      } else if (
        (angle >= 135 && angle <= 180) ||
        (angle >= -180 && angle < -135)
      ) {
        result = 3;
      }
      return result;
    },
    animateClass(flag, obj) {
      if (flag == 1) {
        if (!util.hasClass(obj, "picker-animate2")) {
          util.addClass(obj, "picker-animate2");
          setTimeout(function() {
            util.removeClass(obj, "picker-animate2");
          }, 200);
        }
      } else {
        if (!util.hasClass(obj, "picker-animate1")) {
          util.addClass(obj, "picker-animate1");
          setTimeout(function() {
            util.removeClass(obj, "picker-animate1");
          }, 200);
        }
      }
    },
 getQueryString(name) {
	var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
	var r = window.location.search.substr(1).match(reg);
	if (r != null) return decodeURLcomponent(r[2]); return null;
}
  },
  mounted() {
    var touchBox1 = util.getId("touchBox1");
    var touchBox2 = util.getId("touchBox2");
    var that = this,
      startX,
      startY;
    var handel1 = function(event) {
      startX = event.touches[0].pageX;
      startY = event.touches[0].pageY;
    };
    var handel2 = function(event) {
      let endX, endY;
      endX = event.changedTouches[0].pageX;
      endY = event.changedTouches[0].pageY;
      let direction = that.GetSlideDirection(startX, startY, endX, endY);
      switch (direction) {
        case 0:
          console.log("没滑动");
          break;
        case 1:
          console.log("向上");
          break;
        case 2:
          console.log("向下");
          break;
        case 3:
          that.show ? that.initMonth(1) : that.lineClick(1);
          console.log("向左");
          break;
        case 4:
          console.log("向右");
          that.show ? that.initMonth(-1) : that.lineClick(-1);
          break;
        default:
          break;
      }
    };
    touchBox1.addEventListener("touchstart", handel1, false);
    touchBox1.addEventListener("touchend", handel2, false);
    touchBox2.addEventListener("touchstart", handel1, false);
    touchBox2.addEventListener("touchend", handel2, false);
  }
};
</script>


// WEBPACK FOOTER //
// src/components/financeCalendar/financePickerNew.vue